// Import assets
import { ReactComponent as Icon } from 'assets/icons/ic_button_preview.svg';

// Import styles
import { ButtonWrapper } from './styles';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import hooks
import { usePreviewButton } from './hooks';

type Props = {
	watchPreview: VoidFunction;
	GTMEvent: (buttonText: string) => void;
};

export const PreviewButton = ({ watchPreview, GTMEvent }: Props) => {
	const { handleClick, buttonText } = usePreviewButton(GTMEvent, watchPreview);

	return (
		<ButtonWrapper>
			<Button onClick={handleClick} variant="secondary" modifiers="outlined" icon={<Icon />}>
				{buttonText}
			</Button>
		</ButtonWrapper>
	);
};
